import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {isVisible && (
        <Box
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            right: "2em",
            bottom: "2em",
            display: { xs: "none", md: "flex" },
            zIndex: 999,
            backgroundColor: "#fff",
            color: "#070707",
            transform: "rotate(180deg) scale(1)",
            fontSize: "15px",
            lineHeight: "40px",
            width: "40px",
            height: "40px",
            textAlign: "center",
            boxShadow: "1px 0 22px -9px rgba(0,0,0,.4)",
            transition: "all .3s cubic-bezier(.61,-.12,.08,1.55)",
            cursor: "pointer",
            opacity: isVisible ? 1 : 0,
            pointerEvents: isVisible ? "auto" : "none",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
              transform: "rotate(180deg) scale(1.1)",
              boxShadow: "0 0 20px -9px rgba(0,0,0,.2)",
            },
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: "rotate(180deg)" }}
          >
            <path
              d="M12 19V5M12 5L5 12M12 5L19 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Box>
      )}
    </>
  );
};

export default ScrollToTop;
